const PLACEHOLDER = {
  productfilterbar: 'Search for Name, article number ...',
  systemfilterbar: 'Search for Name ...',
  select_attributes: 'Select Product Attributes ...',
  select_groups: 'Select Product Groups ...',
  select_delivery_address: 'Select delivery address ...',
  contact_at_location: 'Person at the construction',
  project: 'Project',
  select_language: 'Select Language',
  enter_new_password: 'New password ...',
  confirm_new_password: 'Confirm new password ...',
  phone: 'Phone',
  search_ral: 'Search for RAL colors ...',
};

export default PLACEHOLDER;
